module.exports = __webpack_public_path__ + "static/media/carta_58.546eb957.jpg";